import { Layout } from "../../types/theme";

export const layout:Layout = {
	dir: 'rtl',
};
